import * as styles from "./SelectProductType.styles.ts";
import { ProductType } from "@exonn/js-sdk";

import {
  ComplexProductIcon45x45,
  MultipleProductIcon45x45,
  SetProductIcon45x45,
  SingleProductIcon45x45,
} from "src/lib/ui-icon-v2";
import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import type { TFunction } from "i18next";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";

const PRODUCT_TYPES = [
  {
    icon: <SingleProductIcon45x45 />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.SINGLE,
      }),
    type: ProductType.SINGLE,
    helperText: "",
  },
  {
    icon: <SetProductIcon45x45 />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.SET,
      }),
    type: ProductType.SET,
    helperText: "",
  },
  {
    icon: <MultipleProductIcon45x45 />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.MULTIPLE,
      }),
    type: ProductType.MULTIPLE,
    helperText: "",
  },
  {
    icon: <ComplexProductIcon45x45 />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.COMPLEX,
      }),
    type: ProductType.COMPLEX,
    helperText: "",
  },
];

await loadTranslations(TranslationNamespaceEnum.SelectProductTypeModal);

export const SelectProductType = ({
  onSelect,
  onClose,
}: {
  onSelect: (type: ProductType) => void;
  onClose: () => void;
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.SelectProductTypeModal);
  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />

          <ModalV3.Header>
            <ModalV3.Title>{t("title")}</ModalV3.Title>
          </ModalV3.Header>
          <ModalV3.Body>
            <div css={styles.container}>
              {PRODUCT_TYPES.map((item, i) => (
                <button
                  key={i}
                  type="button"
                  tabIndex={0}
                  css={styles.root}
                  onClick={() => {
                    onSelect(item.type);
                    onClose();
                  }}
                >
                  {item.icon}
                  <span css={styles.buttonText}>{item.title(t)}</span>

                  <i
                    className="icon-15-info"
                    title="help text"
                    css={styles.helperIcon}
                  />
                </button>
              ))}
            </div>
          </ModalV3.Body>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
};
